var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"comment_button",class:{ 'comment_button--big': _vm.big, 'comment_button--active': _vm.active }},[_c('img',{staticClass:"comment-icon",attrs:{"src":require("@/assets/img/comment.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }